/**
 * created by wang lei
 分割线 页面
 *
 */
import React, {Component} from 'react';
import cuttingLine from './cuttingLine.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class CuttingLineTool extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'horizontal' );
            }}>
                <img className={"editor-cutting-line-tool-btn"} src={cuttingLine}/>
                <style>{`
                .editor-cutting-line-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-cutting-line-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-cutting-line-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }

}